import { Dialog } from '@sas/nova-commons/components/Dialog';
import { Flow } from '@sas/nova-commons/components/Layouts/Flow';
import { SegmentedButton } from '@sas/nova-commons/components/SegmentedButton';
import { renderInlineCssVars, useDesignTokens } from '@sas/nova-commons/theme';
import { Carousel, SingleColumnView, ViewTiles } from '@sas/react-svg';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useI18n } from '../../../../locale/I18nContext';
import { ObjectSearchState, } from '../../../../store/objectSearch/ObjectSearchState';
import { DemographicsResults } from './DemographicsResults';
import { selectObjectSearchState } from '../../../../store/selectors';
import { useBusyStateAnimationTokens } from '../../../utils/busyStateIndicatorTokens';
import './DemographicsResultsDialog.css';
import cn from './DemographicsResultsDialog.css.json';
export const DemographicsResultsDialogBase = (props) => {
    // Hooks
    const localize = useI18n();
    const dt = useDesignTokens();
    // Local states
    const [layoutModeSelectedIndex, setLayoutModeSelectedIndex] = useState(0);
    const spacingTokens = renderInlineCssVars({ 'spacing-m': dt.tokens['space-base-m'] }, 'demographics');
    const busyAnimationTokens = useBusyStateAnimationTokens();
    return (React.createElement(Dialog, { className: cn.demographicsDialog, style: Object.assign(Object.assign({}, spacingTokens), { minHeight: '20rem', minWidth: '30rem' }), isOpen: props.isOpen, title: localize({ key: 'DemographicsResultsDialog.title.txt' }), firstAction: {
            text: localize({ key: 'DemographicsResultsDialog.edit.txt' }),
            onPress: () => {
                props.onCloseDialog('edit');
            },
        }, dismissAction: {
            text: localize({ key: 'DemographicsResultsDialog.close.txt' }),
            onPress: () => {
                props.onCloseDialog('cancel');
            },
        }, resizable: true, busyStateIndicatorProps: {
            animationTokens: busyAnimationTokens,
            active: props.geoEnrichmentResults === undefined,
            delay: 0,
            overlayStyle: { zIndex: 1 },
        } },
        React.createElement(Flow, { spacing: 's', orientation: 'vertical', className: cn.formContainer },
            Object.keys(props.geoEnrichmentResults || {}).length > 1 ? (React.createElement(SegmentedButton, { orientation: "horizontal", values: [
                    {
                        icon: Carousel,
                        tooltip: localize({ key: 'DemographicsResultsDialog.layout.page.txt' }),
                    },
                    {
                        icon: SingleColumnView,
                        tooltip: localize({ key: 'DemographicsResultsDialog.layout.list.txt' }),
                    },
                    {
                        icon: ViewTiles,
                        tooltip: localize({ key: 'DemographicsResultsDialog.layout.tile.txt' }),
                    },
                ], selectedIndex: layoutModeSelectedIndex, onSelectedIndex: setLayoutModeSelectedIndex })) : null,
            React.createElement(DemographicsResults, { id: props.id, featureIndex: props.featureIndex, type: layoutModeSelectedIndex === 0
                    ? 'carousel'
                    : layoutModeSelectedIndex === 1
                        ? 'list'
                        : 'tiles' }))));
};
export const DemographicsResultsDialog = connect((state, props) => {
    var _a, _b;
    const { features } = (_a = selectObjectSearchState(state, props.id)) !== null && _a !== void 0 ? _a : {};
    const item = features === null || features === void 0 ? void 0 : features.find((feature, index) => {
        return feature.type === 'area' && index === props.featureIndex;
    });
    if (!item) {
        throw new Error(`${props.featureIndex} is not a valid feature index`);
    }
    else {
        return {
            geoEnrichmentResults: (_b = item.demographics) === null || _b === void 0 ? void 0 : _b.data,
        };
    }
}, (dispatch) => ({
    actions: bindActionCreators(ObjectSearchState.actions, dispatch),
}))(DemographicsResultsDialogBase);
